import SuperFetchV2 from '../../superFetchV2';
import { CategoryBannerResponse, UpsertCategoryBannerRequest } from './categoryBannerType';

export const CategoryBannerApi = {
  getCategoryBanner: (categoryId: number): Promise<CategoryBannerResponse> =>
    SuperFetchV2.get(`/categories/${categoryId}/banner`),

  upsertCategoryBanner: (
    categoryId: number,
    payload: UpsertCategoryBannerRequest,
  ): Promise<CategoryBannerResponse> => SuperFetchV2.put(`/categories/${categoryId}/banner`, payload),

  deleteCategoryBanner: (categoryId: number): Promise<void> =>
    SuperFetchV2.delete(`/categories/${categoryId}/banner`),
};
